import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T, useT } from "@repo/transifex";
import { useUpdateTill } from "~/api/tills/hooks/use-update-till";
import { type CustomShopperNameOption } from "~/api/tills/types";
import { Button, SelectCreatable } from "~/components";

type Option = {
  value: CustomShopperNameOption;
  label: string;
};

type SelectCustomShopperNameProps = {
  value: CustomShopperNameOption;
};

export const SelectCustomShopperName = ({
  value
}: SelectCustomShopperNameProps) => {
  const t = useT();

  const { mutate, status, reset } = useUpdateTill();

  const options: Option[] = [
    { value: "off", label: t("Off") },
    { value: "required", label: t("Required") },
    { value: "optional", label: t("Optional") }
  ];

  const option = options.find((option) => option.value === value);

  if (status === "pending")
    return (
      <div className="flex w-full items-center justify-center gap-x-4">
        <FontAwesomeIcon
          className="text-5xl text-text-secondary"
          icon={faSpinner}
          spinPulse
        />
        <span className="text-text-secondary">
          <T _str="Option is being updated..." />
        </span>
      </div>
    );

  if (status === "error")
    return (
      <>
        <T _str="Something went wrong" />
        <Button onClick={reset}>
          <T _str="Retry" />
        </Button>
      </>
    );

  return (
    <>
      <p className="text-text-disabled">
        <T _str="Choose an option" />
      </p>
      <div>
        <SelectCreatable
          className="!text-base"
          onChange={(option) => {
            if (option) {
              mutate({ customShopperName: option.value });
            }
          }}
          options={options}
          placeholder={t("Choose an option")}
          value={option ? { value, label: option.label } : null}
        />
      </div>
    </>
  );
};
